import { render } from "./Attachments.vue?vue&type=template&id=3d8aa638"
import script from "./Attachments.vue?vue&type=script&lang=js"
export * from "./Attachments.vue?vue&type=script&lang=js"

import "./Attachments.vue?vue&type=style&index=0&id=3d8aa638&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/Attachments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d8aa638"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d8aa638', __exports__)) {
    console.log('reload')
    api.reload('3d8aa638', __exports__)
  }
  
  module.hot.accept("./Attachments.vue?vue&type=template&id=3d8aa638", () => {
    console.log('re-render')
    api.rerender('3d8aa638', render)
  })

}


export default __exports__